import React from 'react';
import { MESSAGE_ROLES } from '../../../constants';

const MessageBubble = ({ message, onActionClick }) => {
  const isUser = message.role === MESSAGE_ROLES.USER;
  const actions = message.actions || [];
  const quickReplies = message.quick_replies || [];

  return (
    <div className={`message-wrapper ${isUser ? 'user-message' : 'agent-message'}`}>
      <div className="message-bubble">
        {message.images && message.images.length > 0 && (
          <div className="message-images">
            {message.images.map((img, imgIndex) => (
              <img
                key={imgIndex}
                src={img}
                alt={`Upload ${imgIndex + 1}`}
                className="message-image"
              />
            ))}
          </div>
        )}
        {message.content && (
          <div className="message-text">{message.content}</div>
        )}
        {actions.length > 0 && (
          <div className="message-actions" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
            {actions.map((action) => (
              <button
                key={action.id}
                onClick={() => onActionClick?.(action.title)}
                style={{
                  padding: '6px 14px',
                  borderRadius: '16px',
                  border: '1px solid var(--healthcare-primary, #0d9488)',
                  background: 'transparent',
                  color: 'var(--healthcare-primary, #0d9488)',
                  cursor: 'pointer',
                  fontSize: '13px',
                  fontWeight: 500,
                  transition: 'background 0.15s, color 0.15s',
                }}
                onMouseEnter={(e) => { e.target.style.background = 'var(--healthcare-primary, #0d9488)'; e.target.style.color = '#fff'; }}
                onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = 'var(--healthcare-primary, #0d9488)'; }}
              >
                {action.title}
              </button>
            ))}
          </div>
        )}
        {quickReplies.length > 0 && (
          <div className="message-quick-replies" style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
            {quickReplies.map((reply, i) => (
              <button
                key={i}
                onClick={() => onActionClick?.(reply)}
                style={{
                  padding: '4px 12px',
                  borderRadius: '12px',
                  border: '1px solid #d1d5db',
                  background: '#f9fafb',
                  color: '#374151',
                  cursor: 'pointer',
                  fontSize: '12px',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={(e) => { e.target.style.background = '#e5e7eb'; }}
                onMouseLeave={(e) => { e.target.style.background = '#f9fafb'; }}
              >
                {reply}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
